import React, { useState } from 'react';
import { assignClientOwner } from '../../../api/hub';
import { ErrorState } from '../kit';

// Shared with the disabled placeholder the People card shows while there is no write.
export const ACCEPT_BUTTON = 'h-9 rounded-lg bg-brand px-4 text-sm font-medium text-gray-950 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-not-allowed disabled:opacity-50';

/**
 * Accept the suggested account owner. Rendered only behind canAssignAccountOwner()
 * (false today — see ownerCapability.js; the People card shows a disabled placeholder
 * instead): a real write, so it reports the database's refusal instead of pretending,
 * and it is not re-enabled as "done" on failure.
 *
 * @param {object} props
 * @param {string} props.clientId
 * @param {string} props.memberId          The suggested member's id.
 * @param {(res: object) => void} [props.onAssigned]  Called after a successful write.
 */
export default function AcceptOwnerButton({ clientId, memberId, onAssigned }) {
  const [status, setStatus] = useState('idle'); // idle | saving | done
  const [error, setError] = useState(null);

  const accept = async () => {
    setStatus('saving');
    setError(null);
    try {
      const res = await assignClientOwner(clientId, memberId);
      setStatus('done');
      onAssigned?.(res);
    } catch (err) {
      setError(err?.message || "Couldn't assign the owner.");
      setStatus('idle');
    }
  };

  if (status === 'done') {
    return <span className="text-sm font-medium text-emerald-700 dark:text-emerald-400">Assigned</span>;
  }
  return (
    <div className="shrink-0">
      <button
        type="button"
        onClick={accept}
        disabled={status === 'saving'}
        className={ACCEPT_BUTTON}
      >
        {status === 'saving' ? 'Assigning…' : 'Accept'}
      </button>
      {error && <ErrorState variant="strip" className="mt-2" message={error} />}
    </div>
  );
}
